import { useState, useEffect } from 'react';

/**
 * Reactive countdown to a deadline. Ticks every minute.
 *
 * @returns `{ isOverdue, hours, minutes }` — raw numbers, recalculated each tick.
 */
export const useCountdown = (deadline: Date) => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);

  const msLeft = deadline.getTime() - now;
  const isOverdue = msLeft < 0;
  const absMs = Math.abs(msLeft);
  const hours = Math.floor(absMs / (60 * 60 * 1000));
  const minutes = Math.floor((absMs % (60 * 60 * 1000)) / 60_000);

  return { isOverdue, hours, minutes };
};
